exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".middle[data-v-1ea130a5] {\n  display: flex;\n  align-items: center;\n}\n", ""]);

// exports
